/* eslint-disable */
export default {
  header: '지원팀에 문의',
  toggleTitle: '1. 오류 추적 모드를 켭니다.',
  toggleDescription:
    '오류 추적 모드를 켜면 문제를 찾는 데 도움이 되지만 앱 성능에 약간의 영향이 있을 수 있습니다.',
  downloadTitle: '2. 문제를 복제한 경우 오류 기록을 다운로드합니다.',
  downloadButton: '다운로드',
  downloadDisabledTitle:
    '오류 로그를 다운로드하려면 먼저 오류 추적 모드를 켜세요.',
  sendTitle: '3. 지원 팀에 로그를 보냅니다.',
  createSupportTicket: '지원팀에 문의하려면',
  sendDescription:
    ' 지원 티켓을 만드세요. 그런 다음 문제 해결을 위해 지원팀에 로그를 보내세요.',
  privacyNotice:
    '로그를 다운로드하여 전송하면 RingCentral이 문제 해결 및 오류 처리를 목적으로 특정 로그 관련 정보에 액세스하는 데 동의하는 것으로 간주합니다. RingCentral에서 개인 데이터를 처리하는 방법에 대한 자세한 내용은 ',
  privacyNoticeLink: '서비스 약관',
  and: ' 및 ',
  privacyNoticeEnd: '개인정보처리방침에서 확인할 수 있습니다.',
  needLeavePage:
    '오류 추적이 실행되는 동안 이 페이지에서 나가도 됩니다. 문제를 복제한 경우 이 페이지로 돌아가 로그 파일을 다운로드하세요.',
  downloading: '다운로드 중',
} as const;

// @key: @#@"header"@#@ @source: @#@"Contact support"@#@
// @key: @#@"toggleTitle"@#@ @source: @#@"1. Turn on error tracking mode"@#@
// @key: @#@"toggleDescription"@#@ @source: @#@"This will help us locate your issues, but may slightly affect your app performance."@#@
// @key: @#@"downloadTitle"@#@ @source: @#@"2. Download the error log when you have replicated the issue."@#@
// @key: @#@"downloadButton"@#@ @source: @#@"Download"@#@
// @key: @#@"downloadDisabledTitle"@#@ @source: @#@"Turn on error tracking mode before you can download error log."@#@
// @key: @#@"sendTitle"@#@ @source: @#@"3. Send the log to support team"@#@
// @key: @#@"createSupportTicket"@#@ @source: @#@"Create a support ticket"@#@
// @key: @#@"sendDescription"@#@ @source: @#@" to get in touch with our support team. Then send the log to the support team for troubleshooting."@#@
// @key: @#@"privacyNotice"@#@ @source: @#@"By downloading and sending us the log, you agree to allow RingCentral to access certain log related information for troubleshooting and error handling purposes. For more information on how RingCentral processes personal data, please review our "@#@
// @key: @#@"privacyNoticeLink"@#@ @source: @#@"Terms of Service"@#@
// @key: @#@"and"@#@ @source: @#@" and "@#@
// @key: @#@"privacyNoticeEnd"@#@ @source: @#@"Privacy Notice."@#@
// @key: @#@"needLeavePage"@#@ @source: @#@"You may leave this page while error tracking is running. When you have replicated the issue, return to this page and download the log files."@#@
// @key: @#@"downloading"@#@ @source: @#@"Downloading"@#@
